import React, { useState, useRef, useEffect } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    projectDetails: ''
  });
  const [result, setResult] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const thankYouRef = useRef(null);

  const socialMediaLinks = [
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/sladejustinferrao',
      icon: 'fab fa-linkedin-in',
      textColor: 'text-gray-500',
      hoverColor: 'hover:text-gray-700',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/SladeJustinFerrao',
      icon: 'fab fa-github',
      textColor: 'text-gray-500',
      hoverColor: 'hover:text-gray-700',
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@sladejustinferrao',
      icon: 'fab fa-youtube',
      textColor: 'text-gray-500',
      hoverColor: 'hover:text-gray-700',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/sladeferrao/',
      icon: 'fab fa-instagram',
      textColor: 'text-gray-500',
      hoverColor: 'hover:text-gray-700',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/your-twitter',
      icon: 'fab fa-x-twitter',
      textColor: 'text-gray-500',
      hoverColor: 'hover:text-gray-700',
    }
  ];

  useEffect(() => {
   if (isSubmitted && thankYouRef.current) {
     thankYouRef.current.scrollIntoView({ behavior: 'smooth' });
   }
 }, [isSubmitted]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult("Sending...");

    const payload = new FormData();
    payload.append("access_key", "4dbdf163-63d9-4c55-bbde-4ab8f909bea5");
    payload.append("Name", formData.name);
    payload.append("Email", formData.email);
    payload.append("Company", formData.company);
    payload.append("Service", formData.service);
    payload.append("Project Details", formData.projectDetails);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: payload,
      });
      const data = await response.json();

      if (data.success) {
        setResult("Form Submitted Successfully!");
        // Optionally clear the form state
        setFormData({
          name: '',
          email: '',
          company: '',
          service: '',
          projectDetails: ''
        });
        // Show the tick for a few seconds then replace the form with a thank you message
        setTimeout(() => {
          setIsSubmitted(true);
        }, 2000);
      } else {
        const errMsg = `Submission failed: ${data.message}`;
        setResult(errMsg);
        // Clear the error after 3 seconds so it reverts back
        setTimeout(() => {
          setResult("");
        }, 3000);
      }
    } catch (error) {
      console.error("Submission error:", error);
      const errMsg = "An unexpected error occurred.";
      setResult(errMsg);
      // Clear the error after 3 seconds
      setTimeout(() => {
        setResult("");
      }, 3000);
    }
  };

  return (
    <>
      <div className="mt-28" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Contact Header */}
        <header className="mb-24 px-4 sm:px-0">
          <h1 ref={thankYouRef} className="text-4xl md:text-8xl font-light text-gray-900 mb-4">
            Let's Create
            <span className="block text-gray-600 mt-2">Something Together</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            Get in touch to discuss your next project or collaboration
          </p>
        </header>

        <div className="grid md:grid-cols-[3fr_1fr] gap-16 mb-24 px-2">
          {/* Conditional rendering: if form is submitted, show Thank You message */}
          {!isSubmitted ? (
            <form onSubmit={handleSubmit} className="space-y-8">
              {/* Form fields */}
              <div className="space-y-1">
                <label className="text-sm text-gray-500 font-medium uppercase tracking-wider">Full Name *</label>
                <div className="border-b border-gray-200 pb-2 focus-within:border-gray-900 transition-colors duration-300">
                  <input
                    type="text"
                    placeholder="John Doe"
                    className="w-full px-4 text-3xl placeholder-gray-400 outline-none bg-transparent py-5 leading-[1rem]"
                    required
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                </div>
              </div>

              <div className="space-y-1">
                <label className="text-sm text-gray-500 font-medium uppercase tracking-wider">Email Address *</label>
                <div className="border-b border-gray-200 pb-2 focus-within:border-gray-900 transition-colors duration-300">
                  <input
                    type="email"
                    placeholder="john.doe@email.com"
                    className="w-full p-4 text-3xl placeholder-gray-400 outline-none bg-transparent py-5 leading-[1rem]"
                    required
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </div>
              </div>

              <div className="space-y-1">
                <label className="text-sm text-gray-500 font-medium uppercase tracking-wider">Company *</label>
                <div className="border-b border-gray-200 pb-2 focus-within:border-gray-900 transition-colors duration-300">
                  <input
                    type="text"
                    placeholder="John Doe Inc.&#174;"
                    className="w-full p-4 text-3xl placeholder-gray-400 outline-none bg-transparent py-5 leading-[1rem]"
                    required
                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  />
                </div>
              </div>

              <div className="space-y-1">
                <label className="text-sm text-gray-500 font-medium uppercase tracking-wider">Service Needed *</label>
                <div className="border-b border-gray-200 pb-2 focus-within:border-gray-900 transition-colors duration-300">
                  <input
                    type="text"
                    placeholder="Web Development..."
                    className="w-full p-4 text-3xl placeholder-gray-400 outline-none bg-transparent py-5 leading-[1rem]"
                    required
                    onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                  />
                </div>
              </div>

              <div className="space-y-1">
                <label className="text-sm text-gray-500 font-medium uppercase tracking-wider">Project Details *</label>
                <div className="border-b border-gray-200 pb-2 focus-within:border-gray-900 transition-colors duration-300">
                  <textarea
                    placeholder="Hey Slade, lets work together on..."
                    className="w-full p-4 text-3xl placeholder-gray-400 outline-none bg-transparent py-6 resize-none overflow-hidden transition-all duration-1000"
                    required
                    rows={1}
                    onChange={(e) => {
                      setFormData({ ...formData, projectDetails: e.target.value });
                      e.target.style.height = 'auto';
                      e.target.style.height = `${e.target.scrollHeight}px`;
                    }}
                  />
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="group flex items-center gap-1 text-xl md:text-2xl text-gray-900 transition-all duration-300 pt-8 px-4 relative overflow-hidden pb-0.5 place-self-end"
              >
                <span className="relative">
                  Send Message
                  <span className="absolute -bottom-0.5 left-0 w-0 h-[0.8px] bg-gray-400 transition-all duration-300 group-hover:w-full"></span>
                </span>
                <span className={`${result === "Form Submitted Successfully!" ||
                  result.startsWith("Submission failed") ? 'opacity-0 scale-75' : 'opacity-100'} transform transition-transform duration-500 ease-[cubic-bezier(0.68,-0.55,0.265,1.55)] text-[1.1em] group-hover:translate-x-3`}>
                  →
                </span>
                <span className="relative right-5 w-6 h-5 inline-block">
                  {/* Tick Mark */}
                  <svg
                    className={`absolute inset-0 transition-all duration-500 ${result === "Form Submitted Successfully!"
                      ? 'text-green-500 opacity-100 scale-100'
                      : 'opacity-0 scale-75'
                      }`}
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      d="M5 13l4 4L19 7"
                      className="origin-center transition-all duration-500"
                      style={{
                        strokeDasharray: 24,
                        strokeDashoffset: result === "Form Submitted Successfully!" ? 0 : 24,
                        transition: 'stroke-dashoffset 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}
                    />
                  </svg>
                  {/* Cross Icon for errors */}
                  <svg
                    className={`absolute inset-0 transition-all duration-500 ${result.startsWith("Submission failed")
                      ? 'text-red-500 opacity-100 scale-100'
                      : 'opacity-0 scale-75'
                      }`}
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      d="M6 18L18 6M6 6l12 12"
                      className="origin-center transition-all duration-500"
                      style={{
                        strokeDasharray: 48,
                        strokeDashoffset: result.startsWith("Submission failed") ? 0 : 48,
                        transition: 'stroke-dashoffset 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}
                    />
                  </svg>
                </span>
              </button>

              {/* Fixed Error Feedback Container */}
              <div className="mt-2 text-red-600 text-sm min-h-[1.5rem]">
                {result.startsWith("Submission failed") ? result : <>&nbsp;</>}
              </div>
            </form>
          ) : (
            // Thank You Message appears after successful submission
            <div className="flex flex-col items-center justify-center text-center">
              <h1 className="text-3xl md:text-6xl font-light text-gray-900 mb-4">
            Thank You
            <span className="text-gray-600 mt-2">!</span>
          </h1>
              <p className="text-lg text-gray-600 mb-8">
                Your message has been successfully submitted. We appreciate your interest and will get back to you as soon as possible.
              </p>
              {/* <div className="flex justify-center space-x-6">
                {socialMediaLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${link.textColor} ${link.hoverColor} transition-colors text-2xl`}
                  >
                    <i className={link.icon}></i>
                  </a>
                ))}
              </div> */}
            </div>
          )}

          {/* Contact Details */}
          <div className="space-y-12 md:pl-8 md:border-l md:border-gray-200">
            <div>
              <h3 className="text-xs text-gray-500 font-medium mb-6 uppercase tracking-wider">
                Direct Contact
              </h3>
              <div className="space-y-4 text-lg text-gray-600">
                <div className="pb-1 group">
                  <a
                    href="mailto:sladejustincredible@gmail.com"
                    className="flex items-center gap-3 font-light hover:text-gray-900 transition-colors"
                  >
                    <i className="fas fa-envelope text-gray-500 text-xl w-6"></i>
                    sladejustincredible@gmail.com
                  </a>
                </div>
                <div className="pb-1 group">
                  <a
                    href="tel:+14389241294"
                    className="flex items-center gap-3 font-light hover:text-gray-900 transition-colors"
                  >
                    <i className="fas fa-phone text-gray-500 text-xl w-6"></i>
                    +1 (438) 924-1294
                  </a>
                </div>
                <div className="flex items-center gap-3 font-light">
                  <i className="fas fa-map-marker-alt text-gray-500 text-xl w-6"></i>
                  Toronto, ON, Canada
                </div>
              </div>
            </div>

            {/* Connect Online Section */}
            <div className="pt-12 border-t border-gray-200">
              <h3 className="text-xs text-gray-500 font-medium mb-6 uppercase tracking-wider">
                Connect Online
              </h3>
              <div className="flex flex-col space-y-3">
                {socialMediaLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${link.textColor} text-grey-200 ${link.hoverColor} transition-colors text-lg flex items-center gap-3`}
                  >
                    <i className={`${link.icon} text-2xl w-8`}></i>
                    <span className="font-light">{link.name}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Optional Map Section (commented out) */}
        {/*
        <div className="relative h-screen mb-24 px-4 sm:px-6 lg:px-8">
          <div className="absolute inset-0 bg-gray-100">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317715.7119163245!2d-0.38178406930761225!3d51.52873519756609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2suk!4v1623930407717!5m2!1sen!2suk"
              className="w-full h-full"
              loading="lazy"
            />
          </div>
        </div>
        */}
      </div>
    </>
  );
};

export default Contact;
